@let state = menuState();
@if (state && (state.allowEnrollmentChanges || state.showSso || state.showLeave)) {
  @let org = state.organization;
  <!-- TODO: remove the legacy branch with the VFO1Foundation flag; keep only the side-nav icon button. -->
  @if (legacyFilter) {
    <button
      type="button"
      [id]="'organization-options_button_menu-' + org.id"
      [bitMenuTriggerFor]="optionsMenu"
      class="filter-options-icon"
      [attr.aria-label]="'organizationOptionsMenu' | i18n"
    >
      <i class="bwi bwi-ellipsis-v" aria-hidden="true"></i>
    </button>
  } @else {
    <button
      type="button"
      [id]="'organization-options_button_menu-' + org.id"
      bitIconButton="bwi-ellipsis-h"
      buttonType="side-nav"
      size="xsmall"
      [label]="'vaultOptions' | i18n"
      [bitMenuTriggerFor]="optionsMenu"
    ></button>
  }
  <bit-menu class="filter-organization-options" #optionsMenu>
    <div class="tw-flex tw-min-w-[200px] tw-max-w-[300px] tw-flex-col">
      @if (state.allowEnrollmentChanges) {
        @if (org.resetPasswordEnrolled) {
          <button
            type="button"
            [id]="'organization-options_button_withdraw-account-recovery-' + org.id"
            bitMenuItem
            (click)="toggleResetPasswordEnrollment(org)"
          >
            <bit-icon fixedWidth name="bwi-undo" slot="start" />
            {{ "withdrawAccountRecovery" | i18n }}
          </button>
        } @else {
          <button
            type="button"
            [id]="'organization-options_button_enroll-account-recovery-' + org.id"
            bitMenuItem
            (click)="toggleResetPasswordEnrollment(org)"
          >
            <bit-icon fixedWidth name="bwi-key" slot="start" />
            {{ "enrollAccountRecovery" | i18n }}
          </button>
        }
      }
      @if (state.showSso) {
        @if (org.ssoBound) {
          <button
            type="button"
            [id]="'organization-options_button_unlink-sso-' + org.id"
            bitMenuItem
            (click)="unlinkSso(org)"
          >
            <bit-icon fixedWidth name="bwi-minus-circle" slot="start" />
            {{ "unlinkSso" | i18n }}
          </button>
        } @else {
          <button
            type="button"
            [id]="'organization-options_button_link-sso-' + org.id"
            bitMenuItem
            (click)="handleLinkSso(org)"
          >
            <bit-icon fixedWidth name="bwi-plus-circle" slot="start" />
            {{ "linkSso" | i18n }}
          </button>
        }
      }
      @if (state.showLeave) {
        <button
          type="button"
          [id]="'organization-options_button_leave-' + org.id"
          variant="danger"
          bitMenuItem
          (click)="leave(org)"
        >
          <bit-icon fixedWidth name="bwi-sign-out" slot="start" />
          {{ "leave" | i18n }}
        </button>
      }
    </div>
  </bit-menu>
}
